import {Box} from '@mui/material'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import {styled} from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import PropTypes from 'prop-types'

const PREFIX = 'AllProspectsLoadingError'
const classes = {
  root: `${PREFIX}-root`,
  icon: `${PREFIX}-icon`,
  loadDataBoxAction: `${PREFIX}-loadDataBoxAction`
}

const StyledBox = styled(Box, {shouldForwardProp: (prop) => prop !== 'height'})(({theme, height}) => ({
  marginTop: height / 2,
  [`&.${classes.root}`]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    position: 'relative',
    justifyContent: 'center'
  },

  [`& .${classes.icon}`]: {
    height: '0.4em',
    width: '0.4em'
  },

  [`& .${classes.loadDataBoxAction}`]: {
    fontWeight: theme.typography.heading.fontWeight.bold,
    fontSize: theme.typography.heading.fontSize.s,
    color: theme.palette.common.grey
  }
}))
const LoadingError = ({height}) => {
  return (
    <StyledBox height={height} className={classes.root}>
      <ErrorOutlineIcon
        style={{
          width: classes.icon.width,
          height: classes.icon.height,
          fontSize: '80px'
        }}
        classes={{colorPrimary: classes.icon}}
        color="primary"
      />
      <Typography variant="h6" className={classes.loadDataBoxAction}>
        An error has occurred. Please try again.
      </Typography>
    </StyledBox>
  )
}

LoadingError.propTypes = {
  height: PropTypes.string
}

export default LoadingError
